<script>
    import mapboxgl from 'mapbox-gl';
    import { onMount } from 'svelte';
    import Legend from './components/Legend.svelte';
    import neLand from './data/ne_50m_land.json';
    
    let { width, manifestData, manifestDataEast, copy, params } = $props();
    
    const initLat = 22;
    const initLng = -105;
    let mapContainer = $state();
    let map = $state();
    // let lat = $derived(params.lat || initLat);
    // let lng = $derived(params.lng || initLng);
    // let zoom = $derived(params.zoom || 3.5);

    mapboxgl.accessToken = import.meta.env.VITE_MAPBOX_TOKEN || 'pk.eyJ1IjoiY25uZGlnaXRhbCIsImEiOiJja2V1M3Vyd3kwMDZrMnF0Njdhb3ZhZDk5In0.OURIYzTcS6ZzoWjXJzfANg';
    
    const desktopZoom = 1.4;
    const desktopLat = 0;
    const desktopLng = -160;

    const mobileZoom = 2.295146720358909;
    const mobileLng = -160;
    const mobileLat = 0;

    const isMobile = $derived(width < 500);
    let height = $derived(isMobile ? 450 : 500);
    let stylesLoaded = $state(false);

    onMount(() => {
        if (!mapContainer) return;

        const zoom = isMobile ? mobileZoom : desktopZoom;
        const lng = isMobile ? mobileLng : desktopLng;
        const lat = isMobile ? mobileLat : desktopLat;
        
        map = new mapboxgl.Map({
            container: mapContainer,
            style: 'mapbox://styles/cnndigital/cmo7p8vi9000h01qkdrofds74',
            zoom: zoom,
            projection: 'mercator',
            center: [lng, lat],
            minZoom: zoom,
            maxZoom: zoom,
            dragPan: false,
            scrollZoom: false,
            boxZoom: false,
            dragRotate: false,
            keyboard: false,
            doubleClickZoom: false,
            touchZoomRotate: false,
            touchPitch: false,
        });
        
        map.on('load', () => {
            stylesLoaded = true;
        });
        
        return () => {
            if (map) {
                map.remove();
            }
        };
    });

    $effect(() => {
        if (!map) return;
        const zoom = isMobile ? mobileZoom : desktopZoom;
        const lng = isMobile ? mobileLng : desktopLng;
        const lat = isMobile ? mobileLat : desktopLat;
        
        // Set in safe order to avoid minZoom > maxZoom or maxZoom < minZoom conflicts
        if (zoom > map.getMaxZoom()) {
            map.setMaxZoom(zoom);
            map.setMinZoom(zoom);
        } else {
            map.setMinZoom(zoom);
            map.setMaxZoom(zoom);
        }
        map.jumpTo({ center: [lng, lat], zoom });
    });

    function addRasterLayer(id, tilesetId, beforeLayer, paint = {}) {
        if (map.getLayer(id)) map.removeLayer(id);
        if (map.getSource(id)) map.removeSource(id);

        console.log(tilesetId);

        map.addSource(id, {
            type: 'raster',
            url: `mapbox://${tilesetId}`,
            tileSize: 256,
        });

        map.addLayer({
            id,
            type: 'raster',
            source: id,
            paint: {
                'raster-opacity': 0.9,
                ...paint,
            },
        }, beforeLayer);

        console.log('added raster layer', id, tilesetId);
    }

    $effect(() => {
        if (manifestData && stylesLoaded) {
            const firstLayer = map.getStyle().layers[0]?.id;
            const files = manifestData.files;
            const tilesetId = files[files.length - 1].tileset_id;
            addRasterLayer('sst-raster-west', tilesetId, firstLayer, { 'raster-translate': [1, 0] });
        }
    });

    $effect(() => {
        if (manifestDataEast && stylesLoaded) {
            const firstLayer = map.getStyle().layers[0]?.id;
            const files = manifestDataEast.files;
            const tilesetId = files[files.length - 1].tileset_id;
            addRasterLayer('sst-raster-east', tilesetId, firstLayer, { 'raster-translate': [0, 0] });
        }
    });
</script>

{#if manifestData}
    <Legend {copy} scale={manifestData.color_scale} />
{/if}
<div class="map-wrapper">
    <div bind:this={mapContainer} class="map-container" style="height: {height}px"></div>
</div>

<style lang='scss'>
    .map-wrapper {
        width: 100%;
        position: relative;
    }

    .map-container {
        width: 100%;
        overflow: hidden;
    }
    
    :global(.mapboxgl-ctrl-attrib) {
        font-size: 10px;
    }
    
    :global(.mapboxgl-ctrl-logo) {
        margin: 0 0 2px 2px;
    }
</style>
